export default __webpack_public_path__ + "static/countdown_siri_3-1d51239783905a1e1b4afa7136f4b34c.png";